import React from 'react';
import { NotePencil } from '@phosphor-icons/react';
import { Button } from './styles';

interface EditColumnsButtonProps {
  label: string;
  onClick: () => void;
}

export function EditColumnsButton({
  label,
  onClick,
}: EditColumnsButtonProps) {
  return (
    <Button type="button" onClick={onClick}>
      {label}
      <NotePencil aria-hidden="true" weight="bold" />
    </Button>
  );
}
